<template>
	<div class="msg-analysis-file" v-if="!isError">
		<div class="msg-analysis-file-info">
			<p>{{message.name}}</p>
			<p>{{message.size}}</p>
		</div>
		<div class="msg-analysis-file-icon" :class="icon_class"></div>
	</div>
	<div class="msg-analysis-file-error" v-else>
		文件消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisFile',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: {},
				icon_class: '',
				isError: false
			}
		},
		methods:{
			format(){
				try {
					let obj = JSON.parse(this.msg.content);
					if(obj.suffix === 'txt'){
						this.icon_class = 'msg-analysis-file-icon-txt'
					}else if(obj.suffix === 'pdf'){
						this.icon_class = 'msg-analysis-file-icon-pdf'
					}else if(obj.suffix.indexOf('doc') !== -1){
						this.icon_class = 'msg-analysis-file-icon-doc'
					}else if(obj.suffix.indexOf('ppt') !== -1){
						this.icon_class = 'msg-analysis-file-icon-ppt'
					}else if(obj.suffix.indexOf('xls') !== -1){
						this.icon_class = 'msg-analysis-file-icon-xls'
					}
					obj.size = this.formatFileSize(obj.size)
					this.message = obj
				}catch (e) {
					this.isError = true
				}
			},
			
			formatFileSize(size){
				let fromatStr
				if(size < 1024){
				 fromatStr = size + 'B'
				}else if(size < 1024 * 1024){
				 fromatStr = Math.ceil(100*size/1024) / 100 + 'KB'
				}else{
				 fromatStr = Math.ceil(100*size/1024/1024) / 100 + 'MB'
				}
				return fromatStr
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-file-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-file{
		padding: 5px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		max-width: 224px;
		height: auto;
		cursor: pointer;
		border: 1px solid #e7e7e7;
		border-radius: 2px;
	}
	.msg-analysis-file .msg-analysis-file-info{
		line-height: 18px;
		word-break: break-all;
		text-align: left;
	}
	.msg-analysis-file-info p:last-child{
		font-size: 12px;
		color: #999999;
	}
	.msg-analysis-file .msg-analysis-file-icon{
		width: 40px;
		height: 40px;
		margin-left: 20px;
		background-image: url(../../assets/img/msg-file.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 32px auto;
	}
	.msg-analysis-file .msg-analysis-file-icon-txt{
		background-image: url(../../assets/img/msg-txt.png) !important;
	}
	.msg-analysis-file .msg-analysis-file-icon-ppt{
		background-image: url(../../assets/img/msg-ppt.png) !important;
	}
	.msg-analysis-file .msg-analysis-file-icon-pdf{
		background-image: url(../../assets/img/msg-pdf.png) !important;
	}
	.msg-analysis-file .msg-analysis-file-icon-doc{
		background-image: url(../../assets/img/msg-doc.png) !important;
	}
	.msg-analysis-file .msg-analysis-file-icon-xls{
		background-image: url(../../assets/img/msg-xls.png) !important;
	}
</style>
